module.exports = __webpack_public_path__ + "static/media/blurred_suits_bg2.6566f47c.png";